module.exports = __webpack_public_path__ + "static/media/23_tn.036e1a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/23_tn.jpg
// module id = 161
// module chunks = 0